module.exports = __webpack_public_path__ + "static/media/EMSD_Logo.1df14e2b.png";